var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',{attrs:{"align":"center"}},[_vm._v("\n    Vantagens\n  ")])])}]

export { render, staticRenderFns }